"use client";
import { Container } from "@/components";
import Image, { StaticImageData } from "next/image";
import React, { useRef } from "react";

interface CaseStudyGalleryProps {
  gallery: (string | StaticImageData)[];
  title: string;
}

const CaseStudyDetailsGallery = ({
  gallery,
  title,
}: CaseStudyGalleryProps) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <section ref={sectionRef} className="lg:py-10 py-4">
      <Container className="px-4 lg:px-10 lg:space-y-10 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-10 md:items-end">
          {/* Top Left */}
          <div className="relative w-full overflow-hidden h-100 md:h-125 lg:h-160">
            <Image
              src={gallery[0]}
              alt={`${title} — case study gallery image 1`}
              fill
              priority
              // Two columns from md up, so half the viewport there — without a
              // `sizes` a fill image assumes 100vw and fetches twice the pixels.
              sizes="(max-width: 768px) 100vw, 50vw"
              className="object-cover object-center"
            />
          </div>
          {/* Top Right - Smaller Image */}
          <div className="relative w-full h-75 md:h-100 lg:h-140">
            <Image
              src={gallery[1]}
              alt={`${title} — case study gallery image 2`}
              fill
              quality={100}
              sizes="(max-width: 768px) 100vw, 50vw"
              className="object-cover object-top"
            />
          </div>
        </div>
        {/* Bottom Row - Full Width Image */}
        <div className="md:col-span-2 relative md:aspect-video h-50 md:h-100 lg:h-120 w-full overflow-hidden">
          <Image
            src={gallery[2]}
            alt={`${title} — case study gallery image 3`}
            width={1920}
            quality={100}
            sizes="100vw"
            className="relative w-full h-full"
          />
        </div>
      </Container>
    </section>
  );
};

export default CaseStudyDetailsGallery;
